import { env } from '@/config/env';

/**
 * Resolves a media URL returned by the API.
 *
 * Warning: The files we store are referenced by **relative path**
 * (`/uploads/avatars/…`), never as absolute URLs: the database then holds no
 * environment-bound address, and changing the API domain does not invalidate
 * saved avatars. In exchange the client prefixes them — the file is served by
 * the API, not by the frontend's origin.
 *
 * An absolute URL is returned untouched: a Google account carries the address
 * of a picture hosted by Google.
 *
 * @param url The stored value, possibly absent.
 * @returns An absolute URL, or `null` when there is nothing to display.
 */
export function resolveAssetUrl(url: string | null | undefined): string | null {
  if (!url) return null;
  if (/^(https?:|data:|blob:)/.test(url)) return url;
  return `${env.apiBaseUrl}${url}`;
}
